import React, { useEffect, useState } from "react";
import { Fetch } from "../../services/api";
import { notify } from "../../utils/utils";

const urlBaseAtu = process.env.REACT_APP_ATU_API + "/api/ATU";

export const useMonitoreoV2 = () => {
	const [trackUnidades, setTrackUnidades] = useState([]);
	const [trackUnidadesA, setTrackUnidadesA] = useState([]);
	const [trackUnidadesB, setTrackUnidadesB] = useState([]);
	const [controlesA, setControlesA] = useState([]);
	const [controlesB, setControlesB] = useState([]);
	const [distanciaTotalA, setDistanciaTotalA] = useState(0);
	const [distanciaTotalB, setDistanciaTotalB] = useState(0);
	const [alertas, setAlertas] = useState([]);
	const [polilineas, setPolilineas] = useState([]);

	const listarTrackUnidades = async (codigoEmpresa, codigoRuta) => {
		const response = await Fetch({
			url:
				urlBaseAtu +
				"/listaUnidadesTrackAlertas?" +
				new URLSearchParams({
					codEmpresa: codigoEmpresa,
					idRuta: codigoRuta,
					codUsuario: 1,
				}),
		});

		if (response.isValid) {
			setTrackUnidades(response.content.listadoTraksUnidades);
			setTrackUnidadesA(
				response.content.listadoTraksUnidades.filter(
					(elem) => elem.lado == "A"
				)
			);
			setTrackUnidadesB(
				response.content.listadoTraksUnidades.filter(
					(elem) => elem.lado == "B"
				)
			);
			setAlertas(response.content.listaAlertas);
		} else {
			notify(response.content, "error");
		}
	};

	const listarControles = async (codigoEmpresa, codigoRuta) => {
		const response = await Fetch({
			url:
				urlBaseAtu +
				"/listaControlesLineal?" +
				new URLSearchParams({
					codEmpresa: codigoEmpresa,
					rutas: codigoRuta,
				}),
		});

		if (response.isValid) {
			const controlesLadoA = response.content.filter(
				(elem) => elem.lado == "A"
			);
			setControlesA(controlesLadoA);
			setDistanciaTotalA(
				controlesLadoA.reduce((acumulador, elemento) => {
					return acumulador + elemento.distanciaControlAnterior;
				}, 0)
			);

			const controlesLadoB = response.content
				.filter((elem) => elem.lado == "B")
				.reverse();
			setControlesB(controlesLadoB);
			setDistanciaTotalB(
				controlesLadoB.reduce((acumulador, elemento) => {
					return acumulador + elemento.distanciaControlAnterior;
				}, 0)
			);
		} else {
			notify(response.content, "error");
		}
	};

	const listarPolilineasRecorridos = async (codigoEmpresa, codigoRuta) => {
		const response = await Fetch({
			url:
				urlBaseAtu +
				"/listaRecorridosXB?" +
				new URLSearchParams({
					codEmpresa: codigoEmpresa,
					codRuta: codigoRuta,
				}),
		});

		if (response.isValid) {
			setPolilineas(response.content);
		} else {
			notify(response.content, "error");
		}
	};

	return {
		listarTrackUnidades,
		trackUnidades,
		trackUnidadesA,
		trackUnidadesB,
		alertas,
		listarControles,
		controlesA,
		distanciaTotalA,
		controlesB,
		distanciaTotalB,
		listarPolilineasRecorridos,
		polilineas,
	};
};
